import { graphql } from '@/generated/gql';

export const LOCATION_GROUP_QUERY = graphql(/* GraphQL */ `
  query LocationGroup($offset: Int, $limit: Int, $filterBy: String) {
    locationGroups(offset: $offset, limit: $limit, filterBy: $filterBy) {
      type
      features {
        type
        geometry {
          type
          coordinates
        }
        properties {
          name
          description
        }
      }
    }
  }
`);
